/* global axios */
import ApiClient from '../ApiClient';

class KnowledgeBaseAPI extends ApiClient {
  constructor() {
    super('omni/knowledge_base', { accountScoped: true });
  }

  // GET /api/v1/accounts/:account_id/omni/knowledge_base
  // GET /api/v1/accounts/:account_id/omni/knowledge_base?agent_bot_id=X
  get(params = {}) {
    return axios.get(this.url, { params });
  }

  // GET /api/v1/accounts/:account_id/omni/knowledge_base/bots
  getBots() {
    return axios.get(`${this.url}/bots`);
  }

  // GET /api/v1/accounts/:account_id/omni/knowledge_base/:id
  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  // POST /api/v1/accounts/:account_id/omni/knowledge_base
  create(data) {
    return axios.post(this.url, data);
  }

  // PATCH /api/v1/accounts/:account_id/omni/knowledge_base/:id
  update(id, data) {
    return axios.patch(`${this.url}/${id}`, data);
  }

  // DELETE /api/v1/accounts/:account_id/omni/knowledge_base/:id
  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  // POST /api/v1/accounts/:account_id/omni/knowledge_base/bulk_create
  bulkCreate(entries) {
    return axios.post(`${this.url}/bulk_create`, { entries });
  }

  // POST /api/v1/accounts/:account_id/omni/knowledge_base/:id/regenerate_embedding
  regenerateEmbedding(id) {
    return axios.post(`${this.url}/${id}/regenerate_embedding`);
  }

  // POST /api/v1/accounts/:account_id/omni/knowledge_base/regenerate_all_embeddings
  regenerateAllEmbeddings(onlyMissing = false) {
    return axios.post(`${this.url}/regenerate_all_embeddings`, null, {
      params: { only_missing: onlyMissing },
    });
  }
}

export default new KnowledgeBaseAPI();

